import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import Avatar from 'components/topbar/main/avatar/avatar'
import ClickOutside from 'decorators/click_outside/click_outside_decorator'

import navigationMenuContentTypes from 'helpers/enums/navigationMenuContentTypes'
import NavigationMainContainer from 'containers/navigation_menu/content/main/container'
import NavigationNotificationPreferencesContainer from 'containers/navigation_menu/content/notification_preferences/container'
import NavigationHelpContainer from 'containers/navigation_menu/content/help/container'

import styles from './view.scss'

class NavigationMenuView extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			isVisible: false,
			content: navigationMenuContentTypes.MAIN,
		}
	}

	NAVIGATION_MENU_CONTAINERS = {
		[navigationMenuContentTypes.MAIN]:
			NavigationMainContainer,
		[navigationMenuContentTypes.NOTIFICATION_PREFERENCES]:
			NavigationNotificationPreferencesContainer,
		[navigationMenuContentTypes.HELP]:
			NavigationHelpContainer,
	}

	toggleNavigationMenu = () => {
		this.setState(prevState => ({
			isVisible: !prevState.isVisible,
			content: navigationMenuContentTypes.MAIN,
		}))
	}

	closeNavigationMenu = () => {
		if (this.state.isVisible) {
			this.toggleNavigationMenu()
		}
	}

	renderNavigationMenu = () => {
		const SpecificNavigationMenuContainer = this.NAVIGATION_MENU_CONTAINERS[
			this.state.content
		]
		return <SpecificNavigationMenuContainer
			navigateTo={this.navigateTo}
			closeNavigationMenu={this.closeNavigationMenu}
		/>
	}

	navigateTo = target => {
		this.setState({
			content: target,
		})
	}

	componentDidUpdate(prevProps) {
		if (this.props.view !== prevProps.view) {
			if (this.props.view === navigationMenuContentTypes.NOTIFICATION_PREFERENCES) {
				this.setState({
					isVisible: true,
					content:
						navigationMenuContentTypes.NOTIFICATION_PREFERENCES,
				})
			}
		}
	}

	render() {
		return (
			<ClickOutside clickOutsideHandler={this.closeNavigationMenu}>
				<div styleName='wrapper'>
					<Avatar
						userImage={this.props.userImage}
						onClick={this.toggleNavigationMenu}
					/>
					{ this.state.isVisible &&
						<div styleName='container'>{this.renderNavigationMenu()}</div>
					}
				</div>
			</ClickOutside>
		)
	}
}

NavigationMenuView.propTypes = {
	userImage: PropTypes.string,
	view: PropTypes.string,
}

NavigationMenuView.defaultProps = {
	userImage: '',
	view: null,
}

export default CSSModules(NavigationMenuView, styles, {allowMultiple: true})
